module.exports = __webpack_public_path__ + "media/images/srs-11442c155010fcca3fbd90cc5f658ad4.gif";